import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { mainColor } from '../../constants';
import styled from '@emotion/styled';
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.action.hover,
        color: theme.palette.common.black,
        },
        [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        },
    }));

export default function BasicTable({rows,headers}) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Day</StyledTableCell>
            <StyledTableCell align="center">Start</StyledTableCell>
            <StyledTableCell align="center">End</StyledTableCell>
            <StyledTableCell align="center">Full Day</StyledTableCell>
            <StyledTableCell align="center">Off</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row=>(
            <TableRow
              key={row[0]}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
            
               <TableCell sx={{color:mainColor}} >
                            {row[0]}
                        </TableCell>
              <TableCell align="center">{typeof row[1]!=="string"?row[1].map(i=>(
                <div style={{
                        display:"flex",
                        flexDirection:"column",
                    }} ><p>{i}</p></div>
              )):row[1]}</TableCell>
              <TableCell align="center">{typeof row[2]!=="string"?row[2].map(i=>(
                <div style={{
                        display:"flex",
                        flexDirection:"column",
                    }} ><p>{i}</p></div>
              )):row[2]}</TableCell>
              <TableCell align="center">{row[3]}</TableCell>
              <TableCell align="center">{row[4]}</TableCell>
            </TableRow>

          ))}
          
        </TableBody>
      </Table>
    </TableContainer>
  );
}